import styled, { css } from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

export const Wrap = styled.span<{ $columns?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  max-width: 100%;
  white-space: nowrap;
  ${typographyMixin("body", 4)}

  > svg {
    flex: none;
    width: 0.75rem;
    height: 0.75rem;
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  /* The design's change row: was, a 24px arrow column, then the new value. */
  ${({ $columns }) =>
    $columns &&
    css`
      display: grid;
      grid-template-columns: minmax(0, 1fr) 1.5rem minmax(0, 1fr);
      width: 100%;
      white-space: normal;

      > svg {
        justify-self: center;
      }
    `}
`;

/** The new value and its note, together in the last cell. */
export const After = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: ${spacing[1]};
  min-width: 0;
`;

export const Was = styled.span<{ $empty: boolean; $struck: boolean }>`
  color: ${({ theme, $struck, $empty }) => ($struck || $empty ? theme.colors.text.secondary : theme.colors.text.primary)};
  font-style: ${({ $empty }) => ($empty ? "italic" : "normal")};
  text-decoration: ${({ $struck }) => ($struck ? "line-through" : "none")};
`;

export const New = styled.span<{ $plain?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  padding: ${({ $plain }) => ($plain ? 0 : `0 ${spacing[1]}`)};
  border-radius: ${borderRadius.md};
  background: ${({ theme, $plain }) => ($plain ? "transparent" : theme.colors.primary[100])};
  ${typographyMixin("body", 2)}
  color: ${({ theme, $plain }) => ($plain ? theme.colors.text.primary : theme.colors.primary[500])};

  svg {
    width: 0.75rem;
    height: 0.75rem;
  }
`;

export const Note = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: normal;
`;
